module.exports = __webpack_public_path__ + "static/media/mess2.49168fb1.png";